module.exports = __webpack_public_path__ + "img/icon-device-active.eeca9974.svg";